'use client';

import { useShippingConfidenceDecision } from '@/modules/shippingConfidence/useShippingConfidenceDecision';

/**
 * Headless activation point for the shipping-confidence PDP experiment. Mounted
 * only on the buyer PDP page so a decision is never requested off-PDP.
 * Renders nothing; the friction modal reads the decision via
 * useShippingConfidenceDecision.
 */
export function ShippingConfidenceExperimentGate() {
  useShippingConfidenceDecision();

  return null;
}
